import type { DocEntry } from "@manifest/schema.ts";
import { DocCard } from "./DocCard.tsx";

const CLUSTER_ACCENT: Record<string, string> = {
  About: "#3b82f6",
  "Cell Model": "#10b981",
  Protocols: "#f59e0b",
  "Wallets/Auth": "#a855f7",
  "Tooling/Standards": "#ef4444",
};

export function ClusterSection({
  cluster,
  docs,
  onSelect,
}: {
  cluster: string;
  docs: DocEntry[];
  onSelect: (doc: DocEntry) => void;
}) {
  const accent = CLUSTER_ACCENT[cluster] ?? "#888";
  return (
    <section className="mb-12">
      <div className="flex items-baseline gap-3 mb-5 border-b border-parchment-400/60 pb-3">
        <span
          className="inline-block w-2.5 h-2.5 rounded-full"
          style={{ background: accent }}
          aria-hidden="true"
        />
        <h2 className="font-serif text-3xl font-semibold text-parchment-900">{cluster}</h2>
        <span className="font-mono text-xs uppercase tracking-[0.18em] text-parchment-600">
          {docs.length} {docs.length === 1 ? "doc" : "docs"}
        </span>
      </div>
      <div className="grid gap-2">
        {docs.map((doc, idx) => (
          <DocCard key={doc.id} doc={doc} index={idx + 1} onSelect={onSelect} />
        ))}
      </div>
    </section>
  );
}
